/**
 * @module core/jwt
 * @description JWT verification utilities for core/ (isolated from modules/)
 *
 * Uses resolved AUTH_SECRET via secret-resolver.
 * For full JWT operations (generate tokens), use modules/auth/jwt.utils.js
 */

import jwt from 'jsonwebtoken'
import { getAuthSecret } from '@kernel/crypto/secret-resolver.js'

/** JWT payload shape (mirrors auth module) */
export interface JwtPayload {
  userId: string
  email: string
  roleIds: string[]
  roleNames: string[]
}

/**
 * Get JWT secret
 */
function getSecret(): string {
  return getAuthSecret()
}

/**
 * Verify access token and return payload
 * @throws Error if token is invalid or expired
 */
export function verifyAccessToken(token: string): JwtPayload {
  return jwt.verify(token, getSecret()) as JwtPayload
}
